/**
 * On the dev server: reports an icon the Material Symbols font of index.html does not have, which shows as its name
 * instead. The font only has the icons tools/generate-icon-names.ts finds in the code, it cannot find a name the code
 * only holds in a variable: mark that name where it comes from, `'<name>' as MaterialSymbol`.
 */
export function reportMissingIcons(document: Document) {
  const link = document.querySelector<HTMLLinkElement>('link[href*="family=Material+Symbols"]');
  const names = link && new URL(link.href).searchParams.get('icon_names');
  if (!names) {
    return;
  }
  const available = new Set(names.split(','));
  const reported = new Set<string>();
  const check = () => {
    for (const icon of Array.from(document.querySelectorAll('mat-icon[data-mat-icon-type="font"]'))) {
      const name = icon.textContent?.trim();
      if (name && !available.has(name) && !reported.has(name)) {
        reported.add(name);
        console.error(
          `The icon "${name}" is not in the Material Symbols font of index.html, it shows as its name. ` +
            `Mark it where it comes from: '${name}' as MaterialSymbol, see tools/generate-icon-names.ts.`,
          icon,
        );
      }
    }
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        check();
      }, 100);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  check();
}
